/**
 * The alias to this folder is utils/vue
 *
 * Consider using this file as entry point to the container.
 * Ideally, you should import, bind and register all req  required modules or components from here
 */
import lib from './lib'
import classes from './classes'
import mixins from './mixins'
import * as vuex from './vuexstore/index'
import components from './components'

import services from './services'

import props from './props'

export default {
  lib,
  classes,
  mixins,
  vuex,
  components,
  services,
  props,
}


